import React, { useEffect } from "react"
import * as S from "./animated-text.styles"
import { gsap } from "gsap"
import SplitType from "split-type"

const AnimatedText = ({
  children,
  className,
  isService,
  variant,
  delay,
  LinkComponent,
  ...props
}) => {
  const classStr = className?.split(" ").join("-")

  const Wrapper = LinkComponent ? LinkComponent : S.Wrapper

  useEffect(() => {
    const tl = gsap.timeline()
    const text = new SplitType(`.animated-text-${classStr}`, {
      types: "lines, words",
      lineClass: `line line-${classStr}`,
      wordClass: `word word-${classStr}`,
    })

    tl.to(`.text-wrapper-${classStr}`, {
      autoAlpha: 1,
      duration: 0.2,
      delay: delay ?? 0,
    })

    tl.from(`.line-${classStr} .word-${classStr}`, {
      duration: 1.2,
      y: -200,
      ease: "power4.out",
      delay: 0.5,
      opacity: 0,
      stagger: {
        amount: 0.4,
      },
    })
  }, [])
  return (
    <Wrapper className={`text-wrapper-${classStr}`} {...props}>
      <S.Title
        variant={variant}
        className={`animated-text-${classStr} ${
          isService ? "service" : ""
        } ${className}`}
      >
        {children}
      </S.Title>
    </Wrapper>
  )
}

export default AnimatedText
